// Browser Notification Service

export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    console.log("This browser does not support notifications");
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  if (Notification.permission !== "denied") {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  }

  return false;
};

export const showNotification = async (title, options = {}) => {
  if (!("Notification" in window)) {
    return;
  }

  if (Notification.permission === "granted") {
    try {
      // Mobile browsers (Android/iOS) require using the ServiceWorkerRegistration to show notifications
      if ("serviceWorker" in navigator) {
        // Use getRegistration() instead of .ready to prevent hanging if the SW fails to install
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration && registration.active) {
          return registration.showNotification(title, {
            icon: "/logo192.png",
            badge: "/favicon-32x32.png",
            ...options,
          });
        }
      }

      // Fallback for older desktop environments
      const notification = new Notification(title, {
        icon: "/logo192.png",
        ...options,
      });

      notification.onclick = () => {
        window.focus();
        notification.close();
      };
      return notification;
    } catch (err) {
      console.error("Error creating notification:", err);
    }
  }
};

export const getNotificationPermissionStatus = () => {
  if (!("Notification" in window)) {
    return "unsupported";
  }
  return Notification.permission;
};
